import { render } from "./SocialMediaIconBox.vue?vue&type=template&id=3718262a"
import script from "./SocialMediaIconBox.vue?vue&type=script&lang=ts"
export * from "./SocialMediaIconBox.vue?vue&type=script&lang=ts"

import "./SocialMediaIconBox.vue?vue&type=style&index=0&id=3718262a&lang=scss"
script.render = render

export default script